import React from 'react';
import PropTypes from 'prop-types';
import { Col, Grid, Row, styled, up, css } from '@smooth-ui/core-sc';

import Spend from 'containers/AboutPage/images/Spend.svg';
import Earn from 'components/StatementLoyalty/images/Earned@2x.png';
import Redeem from 'components/StatementLoyalty/images/Redeemed@2x.png';

const InstructionsGrid = styled(Grid)`
  margin-top: -70px;
  .sui-row {
    ${up(
      'md',
      css`
        max-width: 1000px;
        margin: 0 auto;
      `
    )};

    .sui-col {
      position: relative;
      margin-bottom: 40px;

      &:last-child {
        margin-bottom: 0;
      }

      ${up(
        'md',
        css`
          margin: 0 22px;
        `
      )};

      h2 {
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 20px;
      }

      p {
        margin-top: 0;
        font-size: 15px;
      }
    }
  }

  .math-symbols {
    color: #20335d;
    background-color: #fff;
    border-radius: 50%;
    width: 58px;
    height: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
    position: absolute;
    z-index: 1;
    right: 50%;
    bottom: -63px;
    margin-right: -29px;
    box-shadow: 0px 3px 13px 1px rgba(0, 0, 0, 0.25);
    font-family: 'Montserrat', sans-serif;
    font-size: 48px;
    ${up(
      'md',
      css`
        right: -50px;
        margin-right: 0;
        top: 0;
      `
    )};
  }

  .spend {
    background-color: #f68827;
  }

  .earn {
    background-color: #f36f28;
  }

  .redeem {
    background-color: #ef492b;
  }
`;

const Instructions = ({ className, match }) => {
  let text1 =
    'Get more back on your Heatleys purchases! Spend on eligible products to start earning.';
  let text2 =
    'Just register for a Heatleys HUB account and get 1.5 Max Rewards points for every $1 spent on eligible products.';
  let text3 =
    'You can redeem your points on a wide range of exciting rewards, from the latest gadgets and appliances to entertainment and more.';

  if (match.url === '/about') {
    text1 = 'Shop with Heatleys online via The HUB.';
    text2 =
      'Receive 1.5 MAX rewards points for every $1 spent. Look out for promotions where you can earn Bonus MAX Points.';
    text3 =
      'Redeem your MAX points from over a hundred products in the catalogue.';
  }

  return (
    <InstructionsGrid className={className}>
      <Row
        justifyContent="center"
        className="spacer--bottom--large text--white text--center"
      >
        <Col xs={12} md={3} className="spend spacer--around spacer--top">
          <img src={Spend} alt="" height={88} />
          <h2>Spend</h2>
          <p>{text1}</p>
          <div className="h1 vertical math-symbols">+</div>
        </Col>
        <Col xs={12} md={3} className="earn spacer--around spacer--top">
          <img src={Earn} alt="" height={88} />
          <h2>Earn</h2>
          <p>{text2}</p>
          <div className="h1 vertical math-symbols">=</div>
        </Col>
        <Col xs={12} md={3} className="redeem spacer--around spacer--top">
          <img src={Redeem} alt="" height={88} />
          <h2>Redeem</h2>
          <p>{text3}</p>
        </Col>
      </Row>
    </InstructionsGrid>
  );
};

Instructions.propTypes = {
  className: PropTypes.string,
  match: PropTypes.object,
};

Instructions.defaultProps = {
  className: '',
  match: { url: '/' },
};

export default Instructions;
